// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scanner-container {
  display: flex;
  position: relative;
  flex-flow: column;
  height: 100%;
  overflow: hidden;
}
.scanner-container .stub-background {
  background-color: #494545;
}

.title {
  text-align: center;
  color: white;
  text-shadow: 0 0 1px black;
}

.camera-output {
  display: grid;
  align-items: center;
  height: auto;
  max-height: 500px;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  background-color: transparent;
  overflow: hidden;
}

.bottom-toolbar {
  margin-top: auto;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
}
.bottom-toolbar .button {
  background-color: #494545;
}
.bottom-toolbar .mat-icon {
  color: white;
}

.video-background {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: -1;
  filter: blur(30px);
  transform: scale(4);
}

.message {
  width: 100%;
  margin: 0;
  padding: 10px;
  text-align: center;
  border-top: 1px solid white;
  border-bottom: 1px solid white;
  color: white;
  font-size: 12px;
  box-sizing: border-box;
}
.message-success {
  background-color: var(--color-success);
}
.message-process {
  background-color: var(--color-info);
}
.message-warning {
  background-color: var(--color-error);
}`, "",{"version":3,"sources":["webpack://./src/app/view/page/request-uid-scanning/request-uid-scanning.component.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AADJ;AAEI;EACI,yBATgB;AASxB;;AAIA;EACI,kBAAA;EACA,YAAA;EACA,0BAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,6BAAA;EACA,gBAAA;AADJ;;AAIA;EACI,gBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AADJ;AAEI;EACI,yBAxCgB;AAwCxB;AAEI;EACI,YAAA;AAAR;;AAIA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,WAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,2BAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;AADJ;AAEI;EACI,sCAAA;AAAR;AAEI;EACI,mCAAA;AAAR;AAEI;EACI,oCAAA;AAAR","sourcesContent":["$stub-background-color: #494545;\n\n.scanner-container {\n    display: flex;\n    position: relative;\n    flex-flow: column;\n    height: 100%;\n    overflow: hidden;\n    & .stub-background {\n        background-color: $stub-background-color;\n    }\n}\n\n.title {\n    text-align: center;\n    color: white;\n    text-shadow: 0 0 1px black;\n}\n\n.camera-output {\n    display: grid;\n    align-items: center;\n    height: auto;\n    max-height: 500px;\n    width: 100%;\n    max-width: 500px;\n    margin: 0 auto;\n    background-color: transparent;\n    overflow: hidden;\n}\n\n.bottom-toolbar {\n    margin-top: auto;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 10px;\n    box-sizing: border-box;\n    & .button {\n        background-color: $stub-background-color;\n    }\n    & .mat-icon {\n        color: white;\n    }\n}\n\n.video-background {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    z-index: -1;\n    filter: blur(30px);\n    transform: scale(4);\n}\n\n.message {\n    width: 100%;\n    margin: 0;\n    padding: 10px;\n    text-align: center;\n    border-top: 1px solid white;\n    border-bottom: 1px solid white;\n    color: white;\n    font-size: 12px;\n    box-sizing: border-box;\n    &-success {\n        background-color: var(--color-success);\n    }\n    &-process {\n        background-color: var(--color-info);\n    }\n    &-warning {\n        background-color: var(--color-error);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
